import { isWhiteLabel } from "./whiteLabel";

// Contact information for different brands
const CONTACT_INFO = {
  languageAcademy: {
    email: "info@languageacademy.com.au",
    phone: "+61 426230061",
    phoneFormatted: "+61 426 230 061",
    phoneNumber: "61426230061",
    whatsapp: "61426230061",
    address: "46 George Street, Parramatta NSW 2150"
  },
  whiteLabel: {
    email: "info@20task.com", 
    phone: "+918360986507",
    phoneFormatted: "+91 836 098 6507",
    phoneNumber: "918360986507",
    whatsapp: "918360986507",
    altPhone: "+918360829427",
    altPhoneFormatted: "+91 836 082 9427",
    altPhoneNumber: "918360829427",
    address: "20Task Business Hub, India" // You can update this to the actual address
  }
};

export const getContactInfo = () => {
  return isWhiteLabel() ? CONTACT_INFO.whiteLabel : CONTACT_INFO.languageAcademy;
};

export const getEmail = () => getContactInfo().email;
export const getPhone = () => getContactInfo().phone;
export const getPhoneFormatted = () => getContactInfo().phoneFormatted;
export const getPhoneNumber = () => getContactInfo().phoneNumber;
export const getWhatsApp = () => getContactInfo().whatsapp;
export const getAddress = () => getContactInfo().address;